export default __webpack_public_path__ + "static/media/caveat-v9-latin_cyrillic-regular.4a1d0313.svg";